import { Dropdown } from 'shared-utils';

export const joiningOptions: Dropdown[] = [
	{
		label: 'Immediate',
		value: 'Immediate',
	},
	{
		label: 'Within 1 month',
		value: 'Within_1_month',
	},
	{
		label: 'Within 3 months',
		value: 'Within_3_months',
	},
	{
		label: 'After 3 months',
		value: 'After_3_months',
	},
];

export const userWorkExpOptions = ['< 1 Year', '1 Year', '2 Years', '3 Years', '4 Years', '5 Years', '5+ Years'];
